import { Minus, Plus, ShoppingCart } from "lucide-react";
import { useCart } from "./CartContext";

export function unitTextOf(m) {
  if (!m) return "";
  const ul = m.unit_label || "Strip";
  return ul === "Strip" ? `Strip of ${m.pack_size || 10}` : `1 ${ul}`;
}

export default function AddToCartBtn({ m, compact = false, testid }) {
  const { cart, add, setQty } = useCart();
  const qty = cart.find((p) => p.id === m.id)?.qty || 0;

  if (qty === 0) {
    return (
      <button
        disabled={m.in_stock === false}
        onClick={() => add({ ...m, mrp: m.offer_price > 0 ? m.offer_price : m.mrp }, 1)}
        data-testid={testid}
        className={`w-full inline-flex items-center justify-center gap-1.5 font-semibold rounded-full transition-colors ${compact ? "text-xs py-2" : "mt-3 text-xs py-2.5"} ${m.in_stock === false ? "bg-slate-100 text-slate-400 cursor-not-allowed" : "bg-[#064E3B] hover:bg-[#043B2C] text-white"}`}>
        <ShoppingCart className="w-3.5 h-3.5" /> {m.in_stock === false ? "Out of Stock" : compact ? "Add" : "Add to Cart"}
      </button>
    );
  }

  return (
    <div data-testid={`${testid}-stepper`} className={`w-full inline-flex items-center justify-between rounded-full border-2 border-[#064E3B] bg-white ${compact ? "py-1 px-1.5" : "mt-3 py-1.5 px-2"}`}>
      <button onClick={() => setQty(m.id, qty - 1)} data-testid={`${testid}-minus`} aria-label="Kam karein"
        className="w-7 h-7 rounded-full bg-emerald-50 hover:bg-emerald-100 text-emerald-900 flex items-center justify-center transition-colors">
        <Minus className="w-4 h-4" />
      </button>
      <span className="font-mono-num font-extrabold text-sm text-slate-900" data-testid={`${testid}-qty`}>{qty}</span>
      <button onClick={() => qty < 20 && setQty(m.id, qty + 1)} data-testid={`${testid}-plus`} aria-label="Aur add karein"
        className="w-7 h-7 rounded-full bg-[#064E3B] hover:bg-[#043B2C] text-white flex items-center justify-center transition-colors disabled:opacity-40" disabled={qty >= 20}>
        <Plus className="w-4 h-4" />
      </button>
    </div>
  );
}
